var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseField',_vm._b({attrs:{"baseRule":"","label":_vm.label,"placeholder":_vm.placeholder},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'BaseField',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }